import React from 'react';
import PropTypes from 'prop-types';

import {
  flyoutFooterLinkStyle,
  flyoutLinkStyle,
  FlyoutMenuSeparator,
  menuItemsWrapper,
} from 'components/FlyoutMenu/styles';
import Link from '../Link';
import Box from '../../shared/Box/index';
import { MenuItem } from './components/MenuItem';

import { DistributionMenuItem } from './components/DistributionMenuItem';

const getAlignmentStyles = align => {
  switch (align) {
    case 'left':
      return { left: 0 };
    case 'right':
    default:
      return { right: 0 };
  }
};

const FlyoutMenu = ({
  renderHeader,
  renderFooter,
  menuItems,
  align,
  onClickMenuItem,
  borderRadius,
  marginTop,
  paddingTopBottom,
  width,
  onClickFooter,
  shouldShowDistributionItem,
}) => (
  <Box
    color="#ffffff"
    position="absolute"
    marginTop={marginTop || 0}
    width={width || 270}
    dangerouslySetInlineStyle={{
      borderRadius: borderRadius ? `${borderRadius}px` : '6px',
      boxShadow: '0 0 9px 0 rgba(0, 0, 0, 0.17)',
      zIndex: 100,
      ...getAlignmentStyles(align),
    }}
  >
    {renderHeader && (
      <Box
        dangerouslySetInlineStyle={{
          borderBottom: '2px solid #dfe0e1',
        }}
        height={70}
        paddingLeft={14}
        paddingRight={14}
        display="flex"
        alignItems="center"
      >
        {renderHeader}
      </Box>
    )}
    {shouldShowDistributionItem && (
      <DistributionMenuItem onClickMenuItem={onClickMenuItem} />
    )}
    <div className={menuItemsWrapper(paddingTopBottom)}>
      {menuItems.map(item => {
        const {
          type,
          to,
          href,
          onClick,
          label,
          description,
          icon,
          target,
          isDownloadLink,
        } = item;
        switch (type) {
          case 'item':
            return (
              <button
                className={flyoutLinkStyle(borderRadius)}
                key={label}
                onClick={e => {
                  onClickMenuItem();
                  onClick(e);
                }}
              >
                <MenuItem label={label} description={description} icon={icon} />
              </button>
            );
          case 'link':
            return (
              <Link
                to={to}
                href={href}
                key={label}
                onClick={e => {
                  onClickMenuItem();
                  if (onClick) {
                    onClick(e);
                  }
                }}
                className={flyoutLinkStyle(borderRadius)}
                target={target}
                isDownloadLink={isDownloadLink}
              >
                <MenuItem label={label} description={description} icon={icon} />
              </Link>
            );
          case 'separator':
          default:
            return <FlyoutMenuSeparator key={`${type}-1`} />;
        }
      })}
    </div>
    {renderFooter && (
      <Box
        dangerouslySetInlineStyle={{
          borderTop: '2px solid #dfe0e1',
        }}
        height={70}
        display="flex"
        alignItems="center"
      >
        <button
          className={flyoutFooterLinkStyle}
          onClick={() => {
            onClickFooter();
            onClickMenuItem();
          }}
        >
          {renderFooter}
        </button>
      </Box>
    )}
  </Box>
);

FlyoutMenu.defaultProps = {
  shouldShowDistributionItem: false,
  renderHeader: null,
  renderFooter: null,
  align: 'right',
  width: null,
  onClickFooter: () => {},
};
FlyoutMenu.propTypes = {
  shouldShowDistributionItem: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right']),
  renderHeader: PropTypes.element,
  renderFooter: PropTypes.element,
  onClickMenuItem: PropTypes.func.isRequired,
  onClickFooter: PropTypes.func,
  borderRadius: PropTypes.number,
  marginTop: PropTypes.number,
  paddingTopBottom: PropTypes.number,
  width: PropTypes.number,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['item', 'separator', 'link']),
      label: PropTypes.string,
      description: PropTypes.string,
      iconType: PropTypes.string,
      href: PropTypes.string,
      to: PropTypes.string,
      onClick: PropTypes.func,
      icon: PropTypes.shape({
        backgroundColor: PropTypes.string,
        iconColor: PropTypes.string,
        padding: PropTypes.number,
        type: PropTypes.string,
        width: PropTypes.number,
      }),
      target: PropTypes.string,
    })
  ).isRequired,
};

export { FlyoutMenu };
